import React from "react";

import { chipColours } from "@/modules/commonMobile";
import { assetImg } from "@/modules/moduleImporter";
import shortNotation from "@/modules/shortNotation";
import moneyFormat from "@/modules/moneyFormat";

import { IUserdataType, ILanguageType } from "@/types/GlobalTypes";

interface IProps {
	userdata: IUserdataType;
	chipValue: number;

	howToPlayGamePcode: string;

	changeChip: (e: any) => void;
	togglePopupTransactionHistory: (e: any) => void;
	togglePopupResultHistory: (e: any) => void;
	toggleInfoNews: (e: any) => void;
	toggleTooltipSettings: (e: any) => void;
	toggleHowToPlay: (e: any) => void;

	lang: ILanguageType;
	insufficientBalance: boolean;

	updateUserData: (e: any) => void;
}

interface IState {
	refreshBalance: boolean;
}

export function footerButton(tooltip: string, image: string, onClick: (e: React.SyntheticEvent<HTMLButtonElement>) => void, extraProps?: any) {
	return (
		<button className="tip footer" {...extraProps} onClick={onClick}>
			{assetImg("sidemenu", image, "", "sl-icon-footer")}

			<span>
				{tooltip}
			</span>
		</button>
	);
}

export default class DesktopGameFooter extends React.Component<IProps, IState> {
	state = { refreshBalance: false };

	shouldComponentUpdate(nextProps: IProps, nextState: IState) {
		const { chipValue, userdata } = this.props;
		const { refreshBalance } = this.state;
		const { balance } = userdata.user;

		return (
			chipValue !== nextProps.chipValue ||
			balance !== nextProps.userdata.user.balance ||
			refreshBalance !== nextState.refreshBalance
		);
	}

	private refreshBalance() {
		if (!this.state.refreshBalance)
			this.setState({ refreshBalance: true }, () => {
				window.setTimeout(() =>
					this.setState({ refreshBalance: false }),
					2000)
			});

		this.props.updateUserData(null);
	}

	private get balanceText() {
		const { balance, lang, currency } = this.props.userdata.user;
		return moneyFormat(balance, lang, currency)
	}

	private leftFragment() {
		const {
			togglePopupTransactionHistory,
			togglePopupResultHistory,
			lang,
			toggleInfoNews,
			toggleTooltipSettings,
			howToPlayGamePcode,
			toggleHowToPlay
		} = this.props;

		const separator = <div className="footer-separator" />;

		return (
			<div className="footer-left">
				{footerButton(
					lang["txt_transaction_history"],
					"transaction_history.svg",
					togglePopupTransactionHistory
				)}

				{separator}

				{footerButton(
					lang["txt_result_history"],
					"result_history.svg",
					togglePopupResultHistory
				)}
				
				{separator}

				{footerButton(
					lang["txt_news"],
					"news.svg",
					toggleInfoNews
				)}

				{separator}

				{footerButton(
					lang["txt_settings"],
					"gear.svg",
					toggleTooltipSettings
				)}

				{separator}

				{footerButton(
					lang["txt_how_to_play"],
					"how_to_play.svg",
					toggleHowToPlay,
					{ game: howToPlayGamePcode }
				)}
			</div>
		);
	}

	private chipsContainerFragment() {
		const
			{ chipValue, userdata } = this.props,
			{ chipBase } = userdata.user;

		return (
			<div className="chips-container">
				{
					chipBase.map((item, idx) => (
						<div key={"chipBase" + idx}
							className={
								"chip" +
								(chipValue === Number(item) ?
									" active " + chipColours[idx] :
									"")
							}
							{... { value: item }}
							onClick={this.props.changeChip}
						>

							{assetImg("chips", idx + 1 + "_ns")}

							<p style={{ fontSize: item >= 100000 && item < 1000000 ? "80%" : "100%" }}>
								{shortNotation(item)}
							</p>
						</div>
					))
				}
			</div>
		);
	}

	private rightFragment() {
		const { balanceText } = this,
			{
				userdata,
				lang,
				insufficientBalance,
			} = this.props,
			{ refreshBalance } = this.state,
			{ displayNickname } = userdata.user;

		return (
			<div className="footer-right">
				<div className="box-footer">
					<div className="icon-footer">
						{assetImg("sidemenu", "user.svg", "", "sl-icon-footer")}
					</div>

					<div className="caption-footer">
						<div className="label-footer">
							{lang["txt_userid"]}
						</div>

						<div className={"value-footer" + (displayNickname.length >= 14 ? " smaller" : "")}>
							{displayNickname}
						</div>
					</div>
				</div>

				<div className={"box-footer" + (insufficientBalance ? " not-enough-balance" : "")}>
					<div className="icon-footer">
						{assetImg("sidemenu", "balance.svg", "", "sl-icon-footer")}
					</div>

					<div className={"caption-footer"}>
						<div className="label-footer">
							{this.props.lang["txt_balance"]}
						</div>

						<div className={"value-footer" +
							(balanceText.length >= 14 ? " smaller" : "")}>
							{balanceText}

							<button
								className={"button-refresh-balance " + (refreshBalance ? "spin" : "")}
								onClick={() => this.refreshBalance()}
							>
								{assetImg("sidemenu", "refresh.svg")}
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		return (
			<div className="sl-footer">
				{this.leftFragment()}
				{this.chipsContainerFragment()}
				{this.rightFragment()}
			</div>
		);
	}
}
